<template>
    <div>
        <div class="col-12 text-center" v-if="!members.length &gt; 0"><em class="text-muted">No users</em></div>
        <div class="row" v-if="members.length &gt; 0">
            <table class="table mb-0 table-hover">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Member since</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="member in members" :key="member.name + member.id">
                    <td>{{ member.name }}</td>
                    <td>{{ member.email }}</td>
                    <td>{{ member.pivot.role }}</td>
                    <td>{{ member.created_at | date('MMMM Do YYYY') }}</td>
                    <td>
                        <button class="btn btn-default btn-sm" @click="impersonate(member)"
                                v-if="spark.userId !== member.id"><i class="fa fa-search cursor-pointer"> </i>&nbsp;Impersonate
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { impersonate } from '../../../../../spark/resources/assets/js/kiosk/impersonation';

    export default {
        props: {
            members: {type: Array, required: true}
        },

        methods: {
            open() {
                this.$refs.modal.open();
            },
            impersonate
        }
    };
</script>

<style lang="scss" scoped>
    .cursor-pointer:hover {
        color: #0069d1;
        transition: all .1s;
    }
</style>

